import { Component, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SolicitudTicketsComponent } from '../solicitud-tickets/solicitudTickets.component';
import { MejorasTicketsComponent } from '../mejoras-tickets/mejoras-tickets.component';
import { SolicitudPerfilTicketsComponent } from '../perfil-tickets/solicitud-perfil-tickets/solicitudPerfilTickets.component';
import { SolicitudCapacitacionTicketsComponent } from "../solicitud-capacitacion-tickets/solicitud-capacitacion-tickets.component";
import { TicketsService } from '../../tickets.service';
import { GestionUsuariosService } from 'src/app/usuarios/gestionusuarios.service';
import { EmpleadoService } from 'src/app/empleado/empleado.service';
import { Prioridad } from 'src/app/shared/model/tickets/prioridad.model';
import { TicketPerfil } from 'src/app/shared/model/tickets/ticketperfil.model';
import { DatePipe, NgFor, NgStyle } from '@angular/common';
import { Constantes } from 'src/app/utilerias/constantes/constantes';
import { Cliente } from 'src/app/shared/model/ajustesUsuario/cliente.model';
import { Tickets } from 'src/app/shared/model/tickets/tickets.model';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import swal from 'sweetalert2';
import { EstadoMantenimientoService } from 'src/app/mantenimiento-modulos/estado-mantenimiento.service';
import { claveTicket, textoAviso } from 'src/app/mantenimiento-modulos/reglas';
import { ModuloEnMantenimiento } from 'src/app/shared/model/mantenimiento-modulos/mantenimiento-modulos.model';

interface TipoTicket {
  id: number;
  nombre: string;
  color: string;
}

@Component({
    selector: "app-selection-tickets",
    standalone: true,
    templateUrl: "./selection-tickets.component.html",
    styleUrls: ["./selection-tickets.component.css"],
    imports: [MatIconButton, MatIcon, NgFor, NgStyle]
})
export class SelectionTicketsComponent {
  /** Mantenimiento de módulos (16/10/2026): un tipo en mantenimiento lo dice y no abre. */
  private readonly mantenimiento = inject(EstadoMantenimientoService);
  prioridadesFiltradas: Prioridad[];
  prioridades: Prioridad[];
  perfil: TicketPerfil;
  clientes = new Array<Cliente>();
  constructor(
    private dialog: MatDialog,
    public modal: MatDialogRef<SelectionTicketsComponent>,
    private ticketsService: TicketsService,
    private cliente: GestionUsuariosService,
    private empleadoService: EmpleadoService,
    private datePipe: DatePipe,
    private router: Router,
  ) { }

  tipos: TipoTicket[] = [
    { id: 1, nombre: "Infraestructura", color: "#916EE1" },
    { id: 2, nombre: "Perfil", color: "#2F7781" },
    { id: 3, nombre: "Capacitación", color: "#D77D2A" },
    { id: 4, nombre: "Mejoras", color: "#8DB13F" },
  ];

  ngOnInit() { 
    this.perfil = new TicketPerfil();
    this.perfil.ticket = new Tickets();
    this.getPrioridad();
    this.getCliente();
    this.getArea();
    this.mantenimiento.asegurar().subscribe();
  }

  /** El tipo de ticket, si está en mantenimiento (no lo abre nadie, tampoco quien administra el mantenimiento). */
  enMantenimiento(id: number): ModuloEnMantenimiento | undefined {
    const modulo = this.mantenimiento.porClave(claveTicket(id));
    return this.mantenimiento.bloquea(modulo) ? modulo : undefined;
  }

  onCloseClick() {
    this.modal.close();
  }

  modalTicket(id: number) {
    const enMantenimiento = this.enMantenimiento(id);
    if (enMantenimiento) {
      swal.fire({ icon: 'info', title: enMantenimiento.nombre + ' está en mantenimiento', text: textoAviso(enMantenimiento), confirmButtonText: 'Entendido' });
      return;
    }
    switch (id) {
      case 1:
        this.infraesTickets();
        break;
      case 2:
        this.perfilickets();
        break;
      case 3:
        this.capacitacionTickets();
        break;
      case 4:
        this.mejorasTickets();
        break;
      default:
        break;
    }
  }

  infraesTickets(): void {
    this.onCloseClick();
    let dialogRef = this.dialog.open(SolicitudTicketsComponent, {
      disableClose: true,
      autoFocus: true,
      width: "60%",
      panelClass: "custom-modalbox",
    });
  }

  mejorasTickets(): void {
    this.onCloseClick();
    let dialogRef = this.dialog.open(MejorasTicketsComponent, {
      disableClose: true,
      autoFocus: true,
      width: "60%",
      panelClass: "custom-modalbox",
    });
  }

  capacitacionTickets(): void {

   // this.router.navigate(['TICKETS/resumenTicket']);
   this.router.navigate(['TICKETS/SolCapacitacion']);
   this.modal.close();
    // let dialogRef = this.dialog.open(SolicitudCapacitacionTicketsComponent, {
    //   disableClose: true,
    //   autoFocus: true,
    //   width: "60%",
    //   panelClass: "custom-modalbox",
    // });errw
    // dialogRef.afterClosed().subscribe((value) => {
    //   if (value !== null && value !== undefined) {
    //     this.modal.close(value);
    //   } else {
    //     this.modal.close();
    //   }
    // });
  }

  getPrioridad() {
    this.ticketsService.consultarPrioridad().subscribe(resp => {
      if (resp != null) {
        this.prioridades = resp.list;
        this.prioridadesFiltradas = resp.list;
      }
    });
  }

  getCliente() {
    this.cliente.getClientes().subscribe(response => {
      if (response.pCodRetorno === '00000') {
        this.clientes = response.list;
      }
    });
  }

  getArea() {
    this.empleadoService.consultaAreaPuestoEmpleado().subscribe(emp => {
        this.perfil.ticket.nombreSolicitante = emp.persona.nombreCompleto;
        // this.perfil.ticket.fechaSolicitud = this.datePipe.transform(new Date(), 'dd-MMMM-yyyy');
        this.perfil.ticket.fechaSolicitud = new Date();
        this.perfil.ticket.areaSolicitante = emp.area.area;
        this.perfil.ticket.areaResolutora = Constantes.AREA_RESOLUTORA;
    });
  }

  perfilickets(): void {
    // this.onCloseClick();
    // let dialogRef = this.dialog.open(SolicitudPerfilTicketsComponent, {
    //   disableClose: true,
    //   autoFocus: true,
    //   width: "60%",
    //   panelClass: "custom-modalbox",
    //   data: {
    //     prioridades: this.prioridadesFiltradas,
    //     clientes: this.clientes,
    //     perfil: this.perfil.ticket,
    //   },
    // });
    localStorage.setItem('datoPerfil', JSON.stringify(this.perfil.ticket));
    localStorage.setItem('datoClientes', JSON.stringify(this.clientes));
    localStorage.setItem('Prioridades', JSON.stringify(this.prioridadesFiltradas));
    this.router.navigate(['TICKETS/SolPerfil']);
    this.modal.close();
  }

  orgValueChange() {
    this.prioridadesFiltradas = [];
    for (let i = 0; i < this.prioridades.length; i++) {
      if (this.prioridades[i].nombre === 'Alta') {
        if (this.perfil.ticket.tipoSolicitud === 'Perfil') {
          this.prioridadesFiltradas.push(this.prioridades[i]);
        }
      } else {
        this.prioridadesFiltradas.push(this.prioridades[i]);
      }
    }
    this.perfil.ticket.prioridad = null;
  }

}

